import type { InvoiceRecipientDataDto } from '../models/InvoiceRecipientDataDto';
import type { SaveInvoiceRecipientDataDto } from '../models/SaveInvoiceRecipientDataDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvoiceRecipientDataControllerService {

    public static get(
        sportsClubId: number,
    ): CancelablePromise<InvoiceRecipientDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice-recipient-data/{sportsClubId}',
            path: {
                'sportsClubId': sportsClubId,
            },
        });
    }

    public static save(
        sportsClubId: number,
        requestBody: SaveInvoiceRecipientDataDto,
    ): CancelablePromise<InvoiceRecipientDataDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoice-recipient-data/{sportsClubId}',
            path: {
                'sportsClubId': sportsClubId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
